import React, { useEffect, useMemo, useState } from 'react';

import { CircularProgress, Container, makeStyles } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { Redirect, useLocation } from 'react-router-dom';
import { filter } from 'rxjs/operators';

import PackagePaymentSuccess from '../../components/payment/PackagePaymentSuccess';
import PaymentFail from '../../components/payment/PaymentFail';
import PaymentSuccessful from '../../components/payment/PaymentSuccessful';
import SubscriptionPaymentSuccess from '../../components/payment/SubscriptionPaymentSuccess';
import useBlocRef from '../../utils/useBlocRef.hook';

const useStyles = makeStyles(() => {
  return {
    container: {
      paddingTop: '25vh',
    },
  };
});

export default ({ purpose }) => {
  const classes = useStyles();

  const blocRef = useBlocRef('paymentRedirectResultBloc');
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [userDetails, setUserDetails] = useState(blocRef.current.userDetails$.getValue());
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const handleHowItWorks = () => blocRef.current.openHowItWorksDialog();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const sessionId = searchParams.get('session_id');
    blocRef.current.isValidSession(sessionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const sessionSubscription = blocRef.current.isValidSession$.pipe(filter((e) => e !== null)).subscribe((result) => {
      if (result) {
        setSuccess(true);
        setLoading(false);
      }
    });

    const errorSubscription = blocRef.current.error$.pipe(filter((e) => e)).subscribe(() => {
      enqueueSnackbar('Invalid Case Session', { autoHideDuration: 10000, variant: 'error' });
      setLoading(false);
    });

    const userDetailsSub = blocRef.current.userDetails$.subscribe(setUserDetails);

    return () => {
      sessionSubscription.unsubscribe();
      errorSubscription.unsubscribe();
      userDetailsSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const canRequestBeforePay = useMemo(() => {
    return userDetails.workspace?.canRequestBeforePay;
  }, [userDetails]);

  if (!purpose) {
    return <Redirect to="/" push={false} />;
  }

  if (loading) {
    return (
      <Container className={classes.container}>
        <CircularProgress />
      </Container>
    );
  }

  if (!success) {
    return <Redirect to="/" push={false} />;
  }

  if (purpose === 'payment-fail') {
    return <PaymentFail />;
  }

  if (purpose === 'payment-successful') {
    return <PaymentSuccessful workspaceCanRequestBeforePay={canRequestBeforePay} />;
  }

  if (purpose === 'payment-subscription-success') {
    return <SubscriptionPaymentSuccess />;
  }

  if (purpose === 'payment-package-success') {
    return <PackagePaymentSuccess onHowItWorks={handleHowItWorks} />;
  }

  return <Redirect to="/" push={false} />;
};
